import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getActiveJobChats, getJobChatHistory } from "../actions/jobChats.actions";
import { jobChatsQueryKeys } from "../jobChats.queryKeys";

export const useActiveJobChatsQuery = ({ enabled = true } = {}) => {
  const token = sessionStorage.getItem("token");
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);

  return useQuery({
    queryKey: jobChatsQueryKeys.active(activeCompanyId),
    queryFn: () => getActiveJobChats(token),
    enabled: Boolean(token && activeCompanyId) && enabled,
    refetchOnWindowFocus: false,
    staleTime: 15000,
  });
};

export const useJobChatHistoryQuery = ({ enabled = true } = {}) => {
  const token = sessionStorage.getItem("token");
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);

  return useQuery({
    queryKey: jobChatsQueryKeys.history(activeCompanyId),
    queryFn: () => getJobChatHistory(token),
    enabled: Boolean(token && activeCompanyId) && enabled,
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });
};
